/* eslint-disable no-undef, no-underscore-dangle */
import {
  getBusinessInfo,
  getClientById,
  addClient,
} from '@/services/business';
import {
  GET_BUSINESS_INFO,
  CLEAR_BUSINESS_INFO,
  LOADING,
  LOADING_SUCCESS,
} from './mutation-types';

const business = {
  state: {
    info: {
      locations: [],
    },
  },
  mutations: {
    [GET_BUSINESS_INFO](state, info) {
      state.info = info;
    },
    [CLEAR_BUSINESS_INFO](state) {
      state.info = {
        locations: [],
      };
    },
  },
  getters: {
    businessId: state => state.info._id,
    doctorId: (state) => {
      if (state.info.locations[0]) {
        return state.info.locations[0].staff_ids[0];
      }
      return null;
    },
    locationId: (state) => {
      if (state.info.locations[0]) {
        return state.info.locations[0]._id;
      }
      return null;
    },
    currentTimezone: (state) => {
      if (state.info.locations[0]) {
        return state.info.locations[0].timezone_name_iana;
      }
      return null;
    },
    businessHours: (state) => {
      if (state.info.locations[0]) {
        return state.info.locations[0].weekly_hours.daily_hours;
      }
      return null;
    },
  },
  actions: {
    clearBusinessInfo({ commit }) {
      commit(CLEAR_BUSINESS_INFO);
    },
    getClientById({ commit }, clientId) {
      return new Promise((resolve, reject) => {
        commit(LOADING);
        return getClientById(clientId)
          .then((res) => {
            const { data } = res;
            if (!data || !data.clients) {
              const err = new Error('No client found');
              commit(LOADING_SUCCESS);
              reject(err);
            } else {
              commit(LOADING_SUCCESS);
              resolve(data.clients[0]);
            }
          });
      });
    },
    addClient({ commit }, client) {
      return new Promise((resolve, reject) => {
        commit(LOADING);
        return addClient(client)
          .then((res) => {
            const { data } = res;
            commit(LOADING_SUCCESS);
            if (!data || !data.client) {
              const err = new Error('Could not create client.');
              reject(err);
            } else {
              resolve(data.client);
            }
          })
          .catch((err) => {
            commit(LOADING_SUCCESS);
            reject(err);
          });
      });
    },
    getBusinessInfo({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        commit(LOADING);
        if (state.info.locations.length !== 0) {
          return resolve(state.info);
        }
        return getBusinessInfo()
          .then((res) => {
            const { data } = res;
            commit(LOADING_SUCCESS);
            if (!data || !data.business) {
              const err = new Error('No data in response');
              reject(err);
            } else {
              commit(GET_BUSINESS_INFO, data.business);
              resolve(res);
            }
          })
          .catch((err) => {
            // get new jwt token
            if (err.response.status === 401) {
              dispatch('getToken').then(() => getBusinessInfo()
                .then((retryRes) => {
                  const { data } = retryRes;
                  if (!data || !data.business) {
                    const err2 = new Error('No data in response');
                    commit(LOADING_SUCCESS);
                    reject(err2);
                  } else {
                    commit(GET_BUSINESS_INFO, data.business);
                    commit(LOADING_SUCCESS);
                    resolve(retryRes);
                  }
                })
                .catch((retryErr) => {
                  // @todo add loading error action
                  commit(LOADING_SUCCESS);
                  reject(retryErr);
                })).catch(() => {
                // log user out as couldn't get new token
                dispatch('logout');
              });
            } else {
              // @todo add loading error action
              commit(LOADING_SUCCESS);
              reject(err);
            }
          });
      });
    },
  },
};

export default business;



// WEBPACK FOOTER //
// ./src/store/business.js